/* Piko engine: diamonds balance, inventory, product popup, buy-diamonds modal.
   Diamond PACKS are real Shopify products — buying goes straight to checkout.
   The diamond BALANCE lives in localStorage; after a customer's pack order is
   delivered, grant their diamonds (manual/Discord flow, like item delivery). */
(function () {
  'use strict';
  var LS_CREDITS = 'piko_diamonds', LS_INV = 'piko_inventory';
  var CFG = window.PIKO || {};

  var RARITY = window.RARITY = {
    sticker:   { label: 'Sticker',   color: '#f5a623', glow: 'rgba(245,166,35,.45)' },
    common:    { label: 'Common',    color: '#9ca3af', glow: 'rgba(156,163,175,.45)' },
    uncommon:  { label: 'Uncommon',  color: '#22c55e', glow: 'rgba(34,197,94,.5)' },
    rare:      { label: 'Rare',      color: '#1d9bf0', glow: 'rgba(29,155,240,.5)' },
    epic:      { label: 'Epic',      color: '#a855f7', glow: 'rgba(168,85,247,.55)' },
    legendary: { label: 'Legendary', color: '#fbbf24', glow: 'rgba(251,191,36,.55)' },
    mythic:    { label: 'Mythic',    color: '#f43f5e', glow: 'rgba(244,63,94,.6)' },
    secret:    { label: 'SECRET',    color: '#e879f9', glow: 'rgba(232,121,249,.65)', rainbow: true }
  };
  window.RARITY_ORDER = ['common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic', 'secret'];

  function lsGet(k, fb) { try { var v = JSON.parse(localStorage.getItem(k)); return v === null || v === undefined ? fb : v; } catch (e) { return fb; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* DEV: test balance for crate-opening QA (development only) */
  if (lsGet(LS_CREDITS, 0) < 100000000) lsSet(LS_CREDITS, 100000000);

  var App = window.App = {
    getCredits: function () { return lsGet(LS_CREDITS, 0); },
    setCredits: function (n) { lsSet(LS_CREDITS, Math.max(0, Math.round(n))); App.renderCredits(true); },
    addCredits: function (n) { App.setCredits(App.getCredits() + n); },
    spendCredits: function (n) {
      if (App.getCredits() < n) return false;
      App.setCredits(App.getCredits() - n); return true;
    },
    getInv: function () { return lsGet(LS_INV, {}); },
    /* item: {id, name, img, credits, rarity} */
    addToInv: function (item) {
      var inv = App.getInv();
      if (inv[item.id]) inv[item.id].qty += 1;
      else inv[item.id] = { qty: 1, name: item.name, img: item.img, credits: item.credits, rarity: item.rarity };
      lsSet(LS_INV, inv); App.renderInvCount();
    },
    removeFromInv: function (id) {
      var inv = App.getInv(); if (!inv[id]) return false;
      inv[id].qty -= 1; if (inv[id].qty <= 0) delete inv[id]; lsSet(LS_INV, inv);
      App.renderInvCount(); return true;
    }
  };

  App.DIA = '<img class="gg-dia" src="' + (CFG.diamond || '') + '" alt="" aria-hidden="true">';
  App.fmtCr = function (n) { return n.toLocaleString('en-GB'); };
  App.gbp = function (cr) { return (CFG.currency || '£') + (cr / 100).toFixed(2); };
  App.pct = function (p) {
    if (p >= 1) return (Math.round(p * 100) / 100) + '%';
    return p.toFixed(Math.min(10, Math.max(2, -Math.floor(Math.log10(p)) + 1))).replace(/0+$/, '').replace(/\.$/, '') + '%';
  };

  /* ---------- toasts + confetti ---------- */
  var toastWrap;
  App.toast = function (title, sub, color) {
    if (!toastWrap) { toastWrap = document.createElement('div'); toastWrap.className = 'gg-toasts'; document.body.appendChild(toastWrap); }
    var el = document.createElement('div');
    el.className = 'gg-toast';
    if (color) el.style.borderColor = color;
    el.innerHTML = '<b>' + title + '</b>' + (sub ? '<span>' + sub + '</span>' : '');
    toastWrap.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('on'); });
    setTimeout(function () { el.classList.remove('on'); setTimeout(function () { el.remove(); }, 350); }, 3200);
  };
  App.confetti = function (color, n) {
    var colors = [color || '#34d16b', '#2fc463', '#1d9bf0', '#fff'];
    for (var i = 0; i < (n || 40); i++) {
      var c = document.createElement('div');
      c.className = 'cr-confetti';
      c.style.left = (Math.random() * 100) + 'vw';
      c.style.background = colors[i % colors.length];
      c.style.animationDuration = (2.2 + Math.random() * 1.9) + 's';
      c.style.animationDelay = (Math.random() * 0.4) + 's';
      document.body.appendChild(c);
      (function (el) { setTimeout(function () { el.remove(); }, 5000); })(c);
    }
  };

  /* ---------- header widgets ---------- */
  App.renderCredits = function (pulse) {
    document.querySelectorAll('[data-credit-balance]').forEach(function (el) {
      el.textContent = App.fmtCr(App.getCredits());
      if (pulse) { var chip = el.closest('.gg-credits'); if (chip) { chip.classList.remove('pulse'); void chip.offsetWidth; chip.classList.add('pulse'); } }
    });
  };
  App.renderInvCount = function () {
    var inv = App.getInv(), total = 0; Object.keys(inv).forEach(function (k) { total += inv[k].qty; });
    document.querySelectorAll('[data-inv-count]').forEach(function (el) {
      el.textContent = total; el.style.display = total > 0 ? '' : 'none';
    });
  };
  function mountHeaderWidgets() {
    var slot = document.querySelector('.top-right');
    if (!slot || slot.querySelector('.gg-headwidgets')) return;
    var box = document.createElement('div');
    box.className = 'gg-headwidgets';
    box.innerHTML =
      '<span class="gg-credits" title="Your Diamonds">' + App.DIA + ' <b data-credit-balance>0</b></span>'
      + '<button class="gg-buybtn" type="button" data-open-buycredits>' + App.DIA + ' Buy Diamonds</button>'
      + '<button class="gg-invbtn" type="button" data-open-inventory aria-label="Inventory">🎒<span class="gg-invcount" data-inv-count style="display:none">0</span></button>';
    slot.insertBefore(box, slot.firstChild);
    App.renderCredits(); App.renderInvCount();
  }

  /* ---------- buy diamonds: opens the Liquid-rendered section modal ---------- */
  App.openBuyCredits = function () {
    var m = document.querySelector('[data-buycredits]');
    if (!m) { App.toast('Diamonds shop not configured', 'Add diamond products in the theme editor.', '#e0233a'); return; }
    m.hidden = false; requestAnimationFrame(function () { m.classList.add('on'); });
  };

  /* pack flow: click a pack → "Add to cart" appears → adds to the real cart
     and opens the cart drawer (checkout happens from there) */
  function selectPack(card) {
    document.querySelectorAll('.gg-pack.sel').forEach(function (c) { if (c !== card) c.classList.remove('sel'); });
    card.classList.toggle('sel');
  }
  function addPack(btn) {
    var variant = btn.getAttribute('data-dia-add');
    var amt = Number(btn.getAttribute('data-amt') || 0);
    if (!variant) return;
    /* Plain text buttons (e.g. the hero "Buy Now") show a loading label; card
       buttons that contain markup keep their contents so they don't get wiped. */
    var plain = btn.children.length === 0;
    var label = plain ? btn.textContent : null;
    btn.disabled = true; if (plain) btn.textContent = 'Adding…';
    function reset() { btn.disabled = false; if (plain) btn.textContent = label; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      try { localStorage.setItem('piko_pending_dia', String(amt)); } catch (e) {}
      var m = document.querySelector('[data-buycredits]');
      if (m) { m.classList.remove('on'); setTimeout(function () { m.hidden = true; }, 200); }
      var cartBtn = document.querySelector('.cart-btn');
      if (cartBtn) cartBtn.click(); /* opens the cart drawer with the pack inside */
      App.toast('Added to cart', App.fmtCr(amt) + ' Diamonds pack', '#34d16b');
      reset();
    }).catch(function () {
      reset();
      App.toast('Could not add pack', 'Please try again.', '#e0233a');
    });
  }
  /* soft return notice — real crediting is confirmed by the team after payment */
  function pendingDiaNotice() {
    try {
      var amt = Number(localStorage.getItem('piko_pending_dia') || 0);
      if (amt > 0) {
        localStorage.removeItem('piko_pending_dia');
        App.toast(App.fmtCr(amt) + ' Diamonds order received', 'They will be credited to your balance once payment is confirmed.', '#34d16b');
      }
    } catch (e) {}
  }

  /* ---------- inventory ---------- */
  function ensureInvDrawer() {
    if (document.querySelector('[data-invdrawer]')) return;
    var d = document.createElement('div');
    d.className = 'gg-modal gg-invmodal'; d.setAttribute('data-invdrawer', ''); d.hidden = true;
    d.innerHTML = '<div class="gg-modal-card gg-invcard">'
      + '<button class="gg-modal-x" type="button" data-modal-close>✕</button>'
      + '<h3 class="gg-modal-title">🎒 Your Inventory</h3>'
      + '<p class="gg-modal-sub">Items you pulled from crates. Sell returns 60% of value in diamonds.</p>'
      + '<div class="gg-invgrid" data-invgrid></div>'
      + '</div>';
    document.body.appendChild(d);
  }
  App.renderInventory = function () {
    ensureInvDrawer();
    var grid = document.querySelector('[data-invgrid]');
    var inv = App.getInv(), ids = Object.keys(inv);
    if (!ids.length) { grid.innerHTML = '<div class="gg-invempty">Nothing yet — open a crate!</div>'; return; }
    ids.sort(function (a, b) { return window.RARITY_ORDER.indexOf(inv[b].rarity) - window.RARITY_ORDER.indexOf(inv[a].rarity); });
    grid.innerHTML = ids.map(function (id) {
      var p = inv[id], r = RARITY[p.rarity] || RARITY.common, sell = Math.round(p.credits * 0.6);
      return '<div class="gg-invitem" style="--r-color:' + r.color + '">'
        + '<img src="' + p.img + '" alt="" loading="lazy"><div class="gg-invmid">'
        + '<b>' + p.name + '</b><span style="color:' + r.color + '">' + r.label + ' · x' + p.qty + '</span>'
        + '<span class="gg-invval">' + App.DIA + ' ' + App.fmtCr(p.credits) + '</span></div>'
        + '<button class="gg-claimbtn" type="button" data-claim="' + id + '">Claim</button>'
        + '<button class="gg-sellbtn" type="button" data-sell="' + id + '" data-sellval="' + sell + '">Sell<br>+' + App.fmtCr(sell) + '</button>'
        + '</div>';
    }).join('');
  };
  App.openInventory = function () { ensureInvDrawer(); App.renderInventory(); var m = document.querySelector('[data-invdrawer]'); m.hidden = false; requestAnimationFrame(function () { m.classList.add('on'); }); };

  function closeModal(m) { m.classList.remove('on'); setTimeout(function () { m.hidden = true; }, 220); }

  /* ---------- product popup (reads data attrs from the clicked card) ---------- */
  App.openProductCard = function (card) {
    var d = card.dataset;
    var rarity = d.pkRarity || 'common', r = RARITY[rarity] || RARITY.common;
    var credits = Math.round(Number(d.pkPrice || 0));
    var compare = Math.round(Number(d.pkCompare || 0));
    var others = [].slice.call(document.querySelectorAll('[data-pk-card][data-pk-rarity="' + rarity + '"]'))
      .filter(function (c) { return c !== card && c.dataset.pkId !== d.pkId; });
    var seen = {}, more = [];
    others.forEach(function (c) { if (!seen[c.dataset.pkId] && more.length < 4) { seen[c.dataset.pkId] = 1; more.push(c.dataset); } });
    var m = document.createElement('div');
    m.className = 'gg-modal pk-modal'; m.hidden = true;
    m.innerHTML = '<div class="gg-modal-card pk-card" style="--r-color:' + r.color + ';--r-glow:' + r.glow + '">'
      + '<div class="pk-top">'
      + '<button class="pk-share" type="button" title="Copy link" data-pk-share="' + (d.pkUrl || '#') + '">🔗</button>'
      + '<button class="pk-continue" type="button" data-modal-close>‹ Continue Shopping</button>'
      + '</div>'
      + '<div class="pk-main">'
      + '<div class="pk-imgbox' + (rarity === 'secret' ? ' pk-r-secret' : '') + '"><img src="' + d.pkImg + '" alt=""></div>'
      + '<div class="pk-info">'
      + '<h3 class="pk-name">' + d.pkTitle + '</h3>'
      + '<div class="pk-cat">' + (d.pkCat || '').toUpperCase() + ' · <span style="color:' + r.color + '">' + (d.pkBadge || r.label) + '</span></div>'
      + '<div class="pk-price"><span class="pk-gbp">' + App.gbp(credits) + '</span>'
      + (compare > credits ? '<span class="pk-was">' + App.gbp(compare) + '</span>' : '') + '</div>'
      + '<div class="pk-guarantee"><span class="pk-star">★</span><div><b>Item Delivery Guarantee</b><span>Delivered to your account, or your money is automatically refunded.</span></div></div>'
      + '<div class="pk-buyrow">'
      + '<div class="pk-qty"><button type="button" data-qty="-1">−</button><b data-qty-num>1</b><button type="button" data-qty="1">+</button></div>'
      + (d.pkVariant
          ? '<button class="pk-add" type="button" data-add data-variant-id="' + d.pkVariant + '" data-name="' + d.pkTitle + '" data-image="' + d.pkImg + '">🛒 Add to Cart</button>'
          : '<a class="pk-add" href="' + (d.pkUrl || '#') + '">View Item</a>')
      + '</div>'
      + '</div></div>'
      + (more.length ? '<div class="pk-more"><b>More ' + (d.pkBadge || r.label) + ' drops like this:</b><div class="pk-morerow">'
        + more.map(function (x) {
          return '<div class="pk-mini" data-pk-open="' + x.pkId + '"><img src="' + x.pkImg + '" alt="">'
            + '<div class="pk-mininfo"><b>' + x.pkTitle + '</b><span>' + App.gbp(Number(x.pkPrice || 0)) + '</span></div></div>';
        }).join('') + '</div></div>' : '')
      + '</div>';
    document.body.appendChild(m);
    m.hidden = false;
    void m.offsetWidth; // commit the initial (hidden) state so the OPEN transition animates
    requestAnimationFrame(function () { m.classList.add('on'); });
    m.addEventListener('click', function (e) {
      if (e.target === m || e.target.closest('[data-modal-close]')) { m.classList.remove('on'); setTimeout(function () { m.remove(); }, 220); return; }
      var q = e.target.closest('[data-qty]');
      if (q) { var n = m.querySelector('[data-qty-num]'); n.textContent = Math.max(1, Math.min(9, Number(n.textContent) + Number(q.getAttribute('data-qty')))); return; }
      var mini = e.target.closest('[data-pk-open]');
      if (mini) {
        var next = document.querySelector('[data-pk-card][data-pk-id="' + mini.getAttribute('data-pk-open') + '"]');
        m.remove();
        if (next) App.openProductCard(next);
      }
    });
  };

  /* ---------- staggered fade-up reveal for cards ---------- */
  App.initCardReveal = function () {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var cards = [].slice.call(document.querySelectorAll('.gg-card:not(.gg-pre):not(.gg-in), .shc-card:not(.gg-in), .inv-card:not(.gg-pre):not(.gg-in), .cr-crate:not(.gg-pre):not(.gg-in)'));
    cards.forEach(function (c) { c.classList.add('gg-pre'); });
    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (en) { return en.isIntersecting; }).map(function (en) { return en.target; });
      if (!batch.length) return;
      batch.sort(function (a, b) { return a.compareDocumentPosition(b) & 2 ? 1 : -1; });
      batch.forEach(function (el, i) {
        io.unobserve(el);
        el.style.transitionDelay = Math.min(i * 32, 240) + 'ms';
        requestAnimationFrame(function () { el.classList.add('gg-in'); });
        el.addEventListener('transitionend', function h() { el.style.transitionDelay = ''; el.removeEventListener('transitionend', h); });
      });
    }, { threshold: 0.01, rootMargin: '200px 120px 200px 120px' });
    cards.forEach(function (c) { io.observe(c); });
  };

  /* ---------- heading drop-in reveal ---------- */
  App.initTitleReveal = function () {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var sel = '.sec-head h2, .pwc-title, .pbs-topheading h2, .cr-hero-title, .inv-head h1, .upg-head h1, .shc-h, .btl-head h2, .wheel-simple-title';
    var titles = [].slice.call(document.querySelectorAll(sel)).filter(function (el) {
      return !el.classList.contains('gg-tpre') && !el.classList.contains('gg-tin');
    });
    if (!titles.length) return;
    titles.forEach(function (el) { el.classList.add('gg-tpre'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        requestAnimationFrame(function () { en.target.classList.add('gg-tin'); });
      });
    }, { threshold: 0.01, rootMargin: '120px 0px 120px 0px' });
    titles.forEach(function (el) { io.observe(el); });
  };
  /* ---------- global clicks ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-add]') && !e.target.closest('.pk-modal')) {
      var trigger = e.target.closest('[data-pk-open-card]');
      if (trigger) {
        var card = trigger.closest('[data-pk-card]');
        if (card) { e.preventDefault(); App.openProductCard(card); return; }
      }
    }
    if (e.target.closest('[data-open-buycredits]')) { App.openBuyCredits(); return; }
    if (e.target.closest('[data-open-inventory]')) { App.openInventory(); return; }
    var pkAdd = e.target.closest('[data-dia-add]');
    if (pkAdd) { addPack(pkAdd); return; }
    var pkCard = e.target.closest('[data-pack-card]');
    if (pkCard) { selectPack(pkCard); return; }
    var share = e.target.closest('[data-pk-share]');
    if (share) {
      try { navigator.clipboard.writeText(location.origin + share.getAttribute('data-pk-share')); App.toast('Link copied!', '', '#22c55e'); } catch (err) {}
      return;
    }
    var sell = e.target.closest('[data-sell]');
    if (sell) {
      var id = sell.getAttribute('data-sell'), val = Number(sell.getAttribute('data-sellval'));
      var inv = App.getInv(), name = inv[id] ? inv[id].name : 'item';
      if (App.removeFromInv(id)) {
        App.addCredits(val);
        App.toast('Sold ' + name, '+' + App.fmtCr(val) + ' 💎', '#22c55e');
        App.renderInventory();
      }
      return;
    }
    var modal = e.target.closest('.gg-modal');
    if (modal && (e.target === modal || e.target.closest('[data-modal-close]'))) { closeModal(modal); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.gg-modal:not([hidden])').forEach(closeModal);
  });

  /* ---------- auto-credit diamonds from the customer's paid orders ----------
     PIKO_DIA_MAP  (product id -> diamond amount) is emitted by the Buy Diamonds
     section. PIKO_DIA_ORDERS (paid diamond line items) is emitted per logged-in
     customer by the 'diamond-orders' snippet. Each order is credited once, then
     remembered in localStorage so refreshes/other pages never re-credit. */
  function creditDiamondOrders() {
    var map = window.PIKO_DIA_MAP, orders = window.PIKO_DIA_ORDERS;
    if (!map || !orders || !orders.length) return;
    var LS_DONE = 'piko_credited_orders';
    var done = lsGet(LS_DONE, {});
    var perOrder = {};
    orders.forEach(function (li) {
      var amt = map[li.product];
      if (!amt) return;
      var oid = String(li.order);
      perOrder[oid] = (perOrder[oid] || 0) + amt * (li.qty || 1);
    });
    var changed = false;
    Object.keys(perOrder).forEach(function (oid) {
      if (done[oid]) return;
      var total = perOrder[oid];
      if (total <= 0) return;
      App.addCredits(total);
      done[oid] = total;
      changed = true;
      App.toast(App.DIA + ' ' + App.fmtCr(total) + ' Diamonds credited',
                'Added to your balance from your order.', '#34d16b');
      App.confetti('#34d16b', 40);
    });
    if (changed) lsSet(LS_DONE, done);
  }

  function boot() { mountHeaderWidgets(); App.initCardReveal(); App.initTitleReveal(); pendingDiaNotice(); creditDiamondOrders(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
